import { render, staticRenderFns } from "./CargarCamion.vue?vue&type=template&id=badebadc&scoped=true"
import script from "./CargarCamion.vue?vue&type=script&lang=js"
export * from "./CargarCamion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badebadc",
  null
  
)

export default component.exports